<template>
  <b-card no-body>
    <h6 slot="header" class="mb-0">
      <font-awesome-icon icon="info-circle" />ข้อมูลทั่วไป
    </h6>

    <table class="table mb-0">
      <tbody>
        <tr>
          <td class="align-middle">
            <strong>ผลที่ได้รับ</strong>
            <p />
          </td>
          <td class="align-middle">
            <div v-if="toggleEdit == 0">
              {{ value.conclusion }}
            </div>
            <div v-if="toggleEdit == 1">
              <b-form-textarea
                id="textarea"
                v-model="value.conclusion"
                rows="3"
                max-rows="6"
              />
            </div>
          </td>
        </tr>

        <!-- <tr>
          <td class="align-middle">
            <strong>การร่วมมือ</strong>
            <p>การร่วมมือของประชาชนกับโครงการที่จัดขึ้น</p>
          </td>
          <td class="align-middle">
            <p />
            <div v-if="toggleEdit == 0">
              {{ value.cooperation }}
            </div>
            <div v-if="toggleEdit == 1">
              <b-form-textarea
                id="textarea"
                v-model="value.cooperation"
                rows="3"
                max-rows="6"
              />
            </div>
          </td>
        </tr> -->
        <tr>
          <td class="align-middle">
            <strong>ปัญหาและอุปสรรคขณะจัดโครงการ</strong>
          </td>
          <td class="align-middle">
            <div v-if="toggleEdit == 0">
              {{ value.obstacle }}
            </div>
            <div v-if="toggleEdit == 1">
              <b-form-textarea
                id="textarea"
                v-model="value.obstacle"
                rows="3"
                max-rows="6"
              />
            </div>
          </td>
        </tr>
        <tr>
          <td class="align-middle">
            <strong>ปัญหาและอุปสรรคขณะการปฏิบัติงาน</strong>
          </td>
          <td class="align-middle">
            <div v-if="toggleEdit == 0">
              {{ value.obstacleWorking }}
            </div>
            <div v-if="toggleEdit == 1">
              <b-form-textarea
                id="textarea"
                v-model="value.obstacleWorking"
                rows="3"
                max-rows="6"
              />
            </div>
          </td>
        </tr>
        <!-- <tr>
          <td class="align-middle">
            <strong>ปัญหาและอุปสรรคจากครั้งก่อน</strong>
            <p>ปัญหาและอุปสรรคที่เกิดขึ้นขณะจัดโครงการ</p>
          </td>
          <td class="align-middle">
            <div v-if="toggleEdit == 0">
              {{ value.previousObstacle }}
            </div>
            <div v-if="toggleEdit == 1">
              <b-form-group label="ได้นำปัญหา, อุปสรรค และ ข้อเสนอแนะจากครั้งที่ผ่านมา มาปรับปรุงการจัดโครงการหรือกิจกรรมครั้งนี้หรือไม่">
                <b-form-radio-group id="radio-group" v-model="selected" name="radio-sub-component">
                  <b-form-radio value="1">ใช่</b-form-radio>
                  <b-form-radio value="0">ไม่ใช่</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-textarea
                v-if="temp === '1'"
                id="textarea"
                v-model="value.previousObstacle"
                placeholder="โปรดระบุ"
                rows="3"
                max-rows="6"
              />
            </div>
          </td>
        </tr> -->
        <tr>
          <td class="align-middle">
            <strong>ความคิดเห็น</strong>
            <p>ความคิดเห็นจากที่ปรึกษาโครงการ</p>
          </td>
          <td class="align-middle">
            <div>
              <p v-if="toggleEdit == 1" class="text-danger my-3">นักศึกษาไม่สามารถแก้ไขความคิดเห็นของที่ปรึกษาได้</p>
              <pre
                style="font-family: Sarabun; font-size: 1em; white-space: pre-wrap"
                class="font-weight-normal"
                :class="toggleEdit == 1 ? 'text-muted' : null"
              >
                {{ value.comment }}
              </pre>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </b-card>
</template>

<script>

export default {
  props: {
    toggleEdit: { type: Boolean, default: false },
    value: { type: Object, required: true }
  },
  data () {
    return {
      temp: this.value.previousObstacle === '' ? '0' : '1'
    }
  },
  computed: {
    selected: {
      get () { return this.value.previousObstacle === '' ? '0' : '1' },
      set (value) {
        this.temp = value
        if (value === '0') {
          this.value.previousObstacle = ''
        }
      }
    }
  },
  watch: {
    evaluation (newValue) {
      this.$emit('input', newValue)
    }
  }
}
</script>

<style lang="scss" scoped>
td {

  &:first-child {
    background-color: #f2f2f2;
    width: 250px;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
</style>
